// This file serves as a compatibility layer for lucide-react icons
// It provides React Icons alternatives that can be used throughout the project
import React from 'react';
import {
  FiPlusCircle, 
  FiEdit2, 
  FiChevronDown, 
  FiChevronRight, 
  FiTrash2, 
  FiX, 
  FiLink,
  FiLoader,
  FiAlertTriangle,
  FiUser,
  FiHome,
  FiLogOut,
  FiCalendar,
  FiMenu,
  FiSettings,
  FiFile,
  FiFileText,
  FiSearch,
  FiUpload,
  FiDownload,
  FiCheck,
  FiChevronLeft,
  FiChevronUp,
  FiShield,
  FiLock,
  FiAlertCircle,
  FiRefreshCw,
  FiUserCheck,
  FiUserPlus,
  FiDollarSign,
  FiMaximize,
  FiMaximize2,
  FiMinimize,
  FiUsers,
  FiCamera,
  FiSave,
  FiPlay,
  FiPause,
  FiVolume2,
  FiVolumeX,
  FiZoomIn,
  FiZoomOut,
  FiCheckCircle,
  FiXCircle,
  FiEye,
  FiEyeOff,
  FiKey,
  FiPlus,
  FiBook,
  FiHeadphones,
  FiVideo,
  FiGlobe,
  FiCode,
  FiMusic,
  FiFilm,
  FiPenTool,
  FiAward,
  FiBookOpen,
  FiClock,
  FiBell,
  FiMessageCircle,
  FiMessageSquare,
  FiArrowRight,
  FiImage,
  FiTrendingUp,
  FiTrendingDown,
  FiStar,
  FiEdit,
  FiTrash,
  FiBarChart2,
  FiMail,
  FiSend,
  FiInfo,
  FiNavigation,
  FiTool,
  FiPhone,
  FiZap,
  FiRotateCcw,
  FiTable,
  FiTag,
  FiType,
  FiMinus,
  FiMove,
  FiThumbsUp,
  FiPrinter,
  FiPocket
} from 'react-icons/fi';

// Additional icons from other packages for specialized icons
import { 
  FaTrophy, 
  FaMedal, 
  FaLeaf, 
  FaEraser, 
  FaUndo, 
  FaStickyNote, 
  FaPalette 
} from 'react-icons/fa';
import { HiCheck, HiStar, HiGlobe, HiCode, HiUser, HiArrowRight } from 'react-icons/hi';

// Export common lucide-react icons with the same names
export const PlusCircle = (props) => <FiPlusCircle {...props} />;
export const Edit2 = (props) => <FiEdit2 {...props} />;
export const ChevronDown = (props) => <FiChevronDown {...props} />;
export const ChevronRight = (props) => <FiChevronRight {...props} />;
export const ChevronLeft = (props) => <FiChevronLeft {...props} />;
export const ChevronUp = (props) => <FiChevronUp {...props} />;
export const Trash2 = (props) => <FiTrash2 {...props} />;
export const X = (props) => <FiX {...props} />;
export const Link = (props) => <FiLink {...props} />;
export const Loader2 = (props) => <FiLoader className="animate-spin" {...props} />;
export const AlertTriangle = (props) => <FiAlertTriangle {...props} />;
export const User = (props) => <FiUser {...props} />;
export const Home = (props) => <FiHome {...props} />;
export const LogOut = (props) => <FiLogOut {...props} />;
export const Calendar = (props) => <FiCalendar {...props} />;
export const Menu = (props) => <FiMenu {...props} />;
export const Settings = (props) => <FiSettings {...props} />;
export const File = (props) => <FiFile {...props} />;
export const FileText = (props) => <FiFileText {...props} />;
export const Search = (props) => <FiSearch {...props} />;
export const Upload = (props) => <FiUpload {...props} />;
export const Download = (props) => <FiDownload {...props} />;
export const Check = (props) => <FiCheck {...props} />;

// Fix missing icons from error reports
export const ShieldCheck = (props) => <FiShield {...props} />;  
export const Lock = (props) => <FiLock {...props} />; 
export const AlertCircle = (props) => <FiAlertCircle {...props} />; 
export const RefreshCcw = (props) => <FiRefreshCw {...props} />;
export const RefreshCw = (props) => <FiRefreshCw {...props} />; 
export const RotateCcw = (props) => <FiRotateCcw {...props} />;
export const CheckCircle2 = (props) => <FiCheckCircle {...props} />;

// Add other icons found in imports
export const Camera = (props) => <FiCamera {...props} />;
export const Save = (props) => <FiSave {...props} />;
export const Play = (props) => <FiPlay {...props} />;
export const Pause = (props) => <FiPause {...props} />;
export const Volume2 = (props) => <FiVolume2 {...props} />;
export const VolumeX = (props) => <FiVolumeX {...props} />;
export const ZoomIn = (props) => <FiZoomIn {...props} />;
export const ZoomOut = (props) => <FiZoomOut {...props} />;
export const CheckCircle = (props) => <FiCheckCircle {...props} />;
export const XCircle = (props) => <FiXCircle {...props} />;
export const Eye = (props) => <FiEye {...props} />;
export const EyeOff = (props) => <FiEyeOff {...props} />;
export const Key = (props) => <FiKey {...props} />;
export const Plus = (props) => <FiPlus {...props} />;
export const Book = (props) => <FiBook {...props} />;
export const Headphones = (props) => <FiHeadphones {...props} />;
export const Video = (props) => <FiVideo {...props} />;
export const Globe = (props) => <FiGlobe {...props} />;
export const Code = (props) => <FiCode {...props} />;
export const Music = (props) => <FiMusic {...props} />;
export const Film = (props) => <FiFilm {...props} />;
export const Pencil = (props) => <FiPenTool {...props} />; // Fixed: FiPencil -> FiPenTool
export const Award = (props) => <FiAward {...props} />;
export const BookOpen = (props) => <FiBookOpen {...props} />;
export const Clock = (props) => <FiClock {...props} />;
export const Bell = (props) => <FiBell {...props} />;
export const MessageCircle = (props) => <FiMessageCircle {...props} />;
export const ArrowRight = (props) => <FiArrowRight {...props} />;
export const Image = (props) => <FiImage {...props} />;
export const Star = (props) => <FiStar {...props} />;
export const Calculator = (props) => <FiTool {...props} />; // Fixed: FiCalculator -> FiTool
export const Edit = (props) => <FiEdit {...props} />;
export const Trash = (props) => <FiTrash {...props} />;
export const BarChart2 = (props) => <FiBarChart2 {...props} />;
export const Mail = (props) => <FiMail {...props} />;
export const Send = (props) => <FiSend {...props} />;
export const Info = (props) => <FiInfo {...props} />;
export const Navigation = (props) => <FiNavigation {...props} />;
export const Wrench = (props) => <FiTool {...props} />; // Fixed: FiWrench -> FiTool
export const Phone = (props) => <FiPhone {...props} />;
export const Shield = (props) => <FiShield {...props} />;
export const Zap = (props) => <FiZap {...props} />;
export const Sparkles = (props) => <FiStar {...props} />;

// Icons from different packages
export const Trophy = (props) => <FaTrophy {...props} />;
export const Medal = (props) => <FaMedal {...props} />;
export const Leaf = (props) => <FaLeaf {...props} />;
export const CheckIcon = (props) => <HiCheck {...props} />;
export const StarIcon = (props) => <HiStar {...props} />;
export const GlobeIcon = (props) => <HiGlobe {...props} />;
export const CodeIcon = (props) => <HiCode {...props} />;
export const UserIcon = (props) => <HiUser {...props} />;
export const ArrowRightIcon = (props) => <HiArrowRight {...props} />;

// Missing icons for StudentManagement.js
export const UserCheck = (props) => <FiUserCheck {...props} />;
export const UserPlus = (props) => <FiUserPlus {...props} />;
export const DollarSign = (props) => <FiDollarSign {...props} />; // Fixed: FiDollar -> FiDollarSign
export const Maximize = (props) => <FiMaximize {...props} />;
export const Maximize2 = (props) => <FiMaximize2 {...props} />; // Added missing Maximize2
export const Minimize = (props) => <FiMinimize {...props} />;
export const Users = (props) => <FiUsers {...props} />;

// Aliases for icons with the same name as the loader
export const Loader = (props) => <FiLoader {...props} />;

// Add missing icons mentioned in the conversation summary
export const Type = (props) => <FiType {...props} />;
export const Eraser = (props) => <FaEraser {...props} />;
export const Move = (props) => <FiMove {...props} />;
export const Undo = (props) => <FaUndo {...props} />;
export const TrendingUp = (props) => <FiTrendingUp {...props} />;
export const TrendingDown = (props) => <FiTrendingDown {...props} />;
export const Table = (props) => <FiTable {...props} />;
export const Tag = (props) => <FiTag {...props} />;
export const StickyNote = (props) => <FaStickyNote {...props} />;
export const MessageSquare = (props) => <FiMessageSquare {...props} />;
export const Minus = (props) => <FiMinus {...props} />;
export const ThumbsUp = (props) => <FiThumbsUp {...props} />;
export const Palette = (props) => <FaPalette {...props} />;
export const Printer = (props) => <FiPrinter {...props} />;
export const Pocket = (props) => <FiPocket {...props} />;
